<template>
  <div class="inteBox">
    <intNavheaderHealth activeNameCheck="first"></intNavheaderHealth>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div class="titleTopCenterLeftBoxno">添加签约</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div @click="goBack"> <i class="el-icon-back" ></i>返回</div>
           <span style="margin: 0 10px;">|</span> 
          <div class="Content1Title">{{signFamilyType == 0 ? '个人签约' : '家庭签约'}}</div>
        </div>
        <div style="background: #ffffff;padding-top:10px;">
            <div style="background: #F2F3F5;padding:10px 20px;margin-left:40px;width:90%">完善个人信息</div>
        </div>

        <div style="background: #ffffff;min-height:80vh;padding:0 40px;position: relative;">
          <div class="familyTypeBox" v-if="signFamilyType == 1">
              <div style='font-size: 16px;color: #000000;' >家庭成员列表（{{FamilyInfoList.healthRecordFamilyUsers.length}}）</div>
              <div :class="item.relation == '本人' ? 'familyTypeBoxList' : 'familyTypeBoxListNo'" v-for="(item,index) in FamilyInfoList.healthRecordFamilyUsers" :key="index">
                  <img v-if="item.imagePath " :src="CommonPath + item.imagePath">
                  <img v-else src="../../assets/img/reservation/touxiang03.png" alt="">
                  <div class="familyTypeBoxListTag">{{item.relation ? item.relation : '未填'}}</div>
                  <div class="familyTypeBoxListSize">{{item.name}}</div>
              </div>
          </div>
            <div class="signAddBox">
                <div class="doCboxHF signAddTop" style="padding-top:40px">
                    <div class="doCboxHF" style="margin-right:30px">
                        <div style="width:150px;text-align: right;margin-right:10px">
                            <span >签约人姓名</span>
                        </div>
                        <el-input
                        placeholder="请输入内容"
                        v-model="myInfo.name"
                        :disabled="true"
                        style="width: 150px;">
                        </el-input>
                    </div>
                    <div class="doCboxHF" style="margin-right:30px">
                        <div style="width:150px;text-align: right;margin-right:10px">
                            <span>身份证号</span>
                        </div>
                        
                        <el-input
                        placeholder="暂未填写"
                        v-model="myInfo.idCard"
                        :disabled="true"
                        style="width: 250px;">
                        </el-input>
                    </div>
                    <div class="doCboxHF">
                        <div style="width:150px;text-align: right;margin-right:10px">
                            <span >手机号</span>
                        </div>
                        <el-input
                        placeholder="暂未填写"
                        v-model="myInfo.phone"
                        :disabled="true"
                        style="width: 250px;">
                        </el-input>
                    </div>
                </div>
                <div class="doCboxHF signAddTop">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >就诊卡类型</span>
                    </div>
                    <el-select v-model="cardFrom.typeName" placeholder="请选择"  @change="bindPickerChange"    style="width:400px">
                        <el-option
                        v-for="(item,index) in array"
                        :key="index"
                        :label="item"
                        :value="{ value: item, index: index }"
                     
                       >
                        </el-option>
                    </el-select>
                </div>
                <div class="doCboxHF signAddTop" >
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >就诊卡号</span>
                    </div>
                    <el-input  v-if="cardFrom.cardType == 0"
                    placeholder="请先选择就诊卡"
                    v-model="cardFrom.cardNo"
                    :disabled="true"
                    style="width:400px"
                    >
                    </el-input>
                    <el-input  v-if="cardFrom.cardType == 1"
                    placeholder="请输入9位社保卡号"
                    v-model="cardFrom.cardNo"
                    style="width:400px"
                    >
                    </el-input>
                    <el-input  v-if="cardFrom.cardType == 2"
                    placeholder="请输入10位医保卡号"
                    v-model="cardFrom.cardNo"
                    style="width:400px"
                    >
                    </el-input>
                    <el-input  v-if="cardFrom.cardType == 3"
                    placeholder="请输入15位自费卡号"
                    v-model="cardFrom.cardNo"
                    style="width:400px"
                    >
                    </el-input>
                    <el-input  v-if="cardFrom.cardType == 4"
                    placeholder="请输入8~15位医保卡号，字母用大写"
                    v-model="cardFrom.cardNo"
                    style="width:400px"
                    >
                    </el-input>
                </div>
                <div class="doCboxHF signAddTop" v-if="cardFrom.cardType == 4">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >参保地</span>
                    </div>
                    <el-cascader  :placeholder="cardFrom.cardRegionName ? cardFrom.cardRegionName : '请选择参保地'" v-model="cardFrom.regionCardId" :options="RegionData" size="medium" :props="{ emitPath: false, multiple: false, checkStrictly: true, lazy: true, lazyLoad: LasyLoadRegion, value: 'id', label: 'regionName', children: 'childrens' }" style="margin-right: 10px; width: 400px" @change="gochangeCard" ref="refSubCatCard"> </el-cascader>
                </div>
                <div class="doCboxHF signAddTop" >
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >联系地址</span>
                    </div>
                    <el-cascader  :placeholder="cardFrom.regionName ? cardFrom.regionName : '请选择所在区域'" v-model="cardFrom.regionId" :options="RegionData" size="medium" :props="{ emitPath: false, multiple: false, checkStrictly: true, lazy: true, lazyLoad: LasyLoadRegion, value: 'id', label: 'regionName', children: 'childrens' }" style="margin-right: 10px; width: 400px" @change="gochange" ref="refSubCat"> </el-cascader>
                </div>
                <div class="doCboxHF signAddTop">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >街道</span>
                    </div>
                      <el-select v-model="cardFrom.street" placeholder="请选择街道" @change="confirmStreet">
                        <el-option
                          v-for="item in streetData"
                          :key="item.value"
                          :label="item.regionName"
                          :value="{ regionName: item.regionName, regionId: item.id }">
                        </el-option>
                      </el-select>
                </div>
                <div class="doCboxHF signAddTop">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >居委会</span>
                    </div>
                      <el-select v-model="cardFrom.streetOffices" placeholder="请选择现居地居委会" @change="confirmstreetOffices">
                        <el-option
                          v-for="item in streetOfficesData"
                          :key="item.value"
                          :label="item.regionName"
                          :value="{ regionName: item.regionName, regionId: item.id }">
                        </el-option>
                      </el-select>
                </div>
                <div class="doCboxHF signAddTop" >
                    <div style="width:150px;text-align: right;margin-right:10px">
                        <span >详细地址</span>
                    </div>
                    <el-input 
                        placeholder="请输入详细地址"
                        v-model="cardFrom.address"
                        style="width:720px"
                        >
                    </el-input>
                </div>
                <div v-for="(item,index) in qitaList" :key="index">
                    <div class="doCboxHF signAddTop" >
                        <div style="width:150px;text-align: right;margin-right:10px">
                        </div>
                        <div style="">
                            <span >紧急联系人{{ index+1 }}</span>
                            <span @click="deleteQT(item,index)" style="font-weight: bold;color: #00AFB5;margin-left:25px" >删除</span>
                        </div>
                    </div>
                    
                    <div class="doCboxHF">
                        <div class="doCboxHF signAddTop" >
                            <div style="width:150px;text-align: right;margin-right:10px">
                                <span >姓名</span>
                            </div>
                            <el-input 
                                placeholder="请输入姓名"
                                v-model="item.name"
                                style="width:300px"
                                >
                            </el-input>
                        </div>
                        <div class="doCboxHF signAddTop" >
                            <div style="width:150px;text-align: right;margin-right:10px">
                                <span >关系</span>
                            </div>
                            <el-input 
                                placeholder="请输入联系人关系"
                                v-model="item.relation"
                                style="width:300px"
                                >
                            </el-input>
                        </div>
                    </div>
                    <div class="doCboxHF">
                        <div class="doCboxHF signAddTop" >
                            <div style="width:150px;text-align: right;margin-right:10px">
                                <span >身份证号</span>
                            </div>
                            <el-input 
                                placeholder="请输入身份证号"
                                v-model="item.idCard"
                                style="width:300px"
                                >
                            </el-input>
                        </div>
                        <div class="doCboxHF signAddTop" >
                            <div style="width:150px;text-align: right;margin-right:10px">
                                <span >手机号</span>
                            </div>
                            <el-input 
                                placeholder="请输入联系电话"
                                v-model="item.phone"
                                style="width:300px"
                                >
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="doCboxHF signAddTop" @click="addQT">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        
                    </div>
                    <div class="addDocPerList">
                       + 添加紧急联系人
                    </div>
                </div>
                <div class="doCboxHF signAddTop">
                    <div style="width:150px;text-align: right;margin-right:10px">
                        
                    </div>
                    <div class="">
                        <el-button size="medium" @click="goNextPre">取消</el-button>
                        <el-button size="medium" type="primary" @click="goNextDes">提交申请</el-button>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
  </div>
</template>
<script>
import intNavheaderHealth from "../../components/intNavheaderHealth";
import { healthRecord } from "../../components/healthRecord/healthRecord";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
export default {
  components: {
    intNavheaderHealth,
  },
  data() {
    var healthRecordData = new healthRecord(
      this.TokenClient,
      this.Services.Authorization
    );
    var region = new shoppingMall(this.TokenClient, this.Services.Authorization);
    return {
        healthRecordDomain: healthRecordData,
        Region: region,
        userInfo: this.$store.state.localData.userInfo,
        myInfo:{},
        healthRecordId:this.$route.query.id,
        healthRecordFamilyId:this.$route.query.healthRecordFamilyId,
        signFamilyType:this.$route.query.type,
        array:['请选择就诊卡类型','社保卡','医保卡','统一自费卡','异地医保卡',],
        cardFrom:{
            cardType:0,
            typeName:'',
            cardNo:'',
            cardProvince:'',
            cardCity:'',
            cardArea:'',
            province:'',
            city:'',
            area:'',
            street:'',
            streetOffices:'',
            regionName:'',
            regionId:'',
            cardRegionName:'',
            regionCardId:'',
            address:''
        },
        RegionData: [],
        qitaList:[],
        streetOfficesIndex:0,
				streetOfficesId:0,
				streetOfficesData:[],
        streetRegionId:0,
				streetIndex:0,
				streetData:[],
        healthRecordData:{},
        FamilyInfoList:{}
    };
  },
  mounted(){
    this.GetHealthRecordByHealthIdMy()
    this.InitialRegion();
  },
  methods: {
      goBack() {
        this.$router.go(-1);
      },
    	getHealthRecordFamilyInfo() {
        var _this = this
        _this.healthRecordDomain.GetHealthRecordFamilyInfo(
            _this.healthRecordId,
            function (data) {
                _this.FamilyInfoList = data.data
            },
            function (error) {
            console.log(error);
            }
        );
			},
    goNextPre(){
        var _this = this
      	_this.$confirm('是否取消签约?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$router.go(-1);
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
		goNextDes(){

				let params =[
					{
						signDoctorId:this.userInfo.id,
						signDoctorType:this.userInfo.doctorHealthManagerType,
						organizationId:this.userInfo.organizationId,
						signApplyType:1,
						signFamilyType:this.signFamilyType,
						healthRecordId:this.healthRecordId,
						healthRecordFamilyId:this.healthRecordFamilyId
						// signFile:this.auditSignImg
					}
				]
				this.healthRecordData = this.cardFrom
				this.healthRecordData.healthRecordId = this.healthRecordId
				this.healthRecordData.healthRecordFamilyId = this.healthRecordFamilyId
        this.healthRecordData.emergencyContacts = []
        this.qitaList.map((res,index)=>{
          res.rank = index
          if (res.name != '') {
            this.healthRecordData.emergencyContacts.push(res)
          }
        })
				this.healthRecordData.healthRecordSignAttas = params
        var _this = this
        _this.healthRecordDomain.AddHealthRecordSign(
            _this.healthRecordData,
            function (data) {
              _this.$message({
                  message: '提交成功',
                  type: 'success'
              });
              _this.$router.push({
                name: "signingApplyList",
              });
            },
            function (error) {
            console.log(error);
            }
        );
		},
    confirmStreet(e){
      var _this = this
      _this.cardFrom.street = e.regionName
      _this.streetOfficesId = e.regionId
      _this.cardFrom.streetOffices = ''
      _this.streetRegionId = 0
      _this.Region.Regions(
        _this.streetOfficesId,
        function (data) {
          _this.streetOfficesData = data.data;
        },
        function (err) {
          console.log(err);
        }
      )
    },
    confirmstreetOffices(e){
      console.log(e)
      this.cardFrom.streetOffices = e.regionName
      this.streetRegionId = e.regionId
    },
    deleteQT(item,index){
        this.qitaList.splice(index, 1)
    },
    addQT(){
        this.qitaList.push({
            name:'',
            relation:'',
            phone:'',
            idCard:''
        })
    },
    InitialRegion() {
      var _this = this;
      _this.Region.Regions(
        null,
        function (data) {
          _this.RegionData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    LasyLoadRegion(node, resolve) {
      var _this = this;
      _this.Region.Regions(
        node.value,
        function (data) {
          for (var dataIndex = 0; dataIndex < data.data.length; dataIndex++) {
            data.data[dataIndex].leaf = data.data[dataIndex].regionLevel >= 3;
          }
          resolve(data.data);
        },
        function (err) {
          resolve([]);
        }
      );
    },
    gochangeCard(){
        this.cardFrom.cardProvince = this.$refs["refSubCatCard"].getCheckedNodes()[0].pathLabels[0]
        this.cardFrom.cardCity = this.$refs["refSubCatCard"].getCheckedNodes()[0].pathLabels[1]
        this.cardFrom.cardArea = this.$refs["refSubCatCard"].getCheckedNodes()[0].pathLabels[2]
        this.cardFrom.cardRegionName = this.$refs["refSubCatCard"].getCheckedNodes()[0].data.fullName;
    },
    gochange() {
        var _this = this
        _this.cardFrom.province = _this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels[0]
        _this.cardFrom.city = _this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels[1]
        _this.cardFrom.area = _this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels[2]
        _this.cardFrom.regionName = _this.$refs["refSubCat"].getCheckedNodes()[0].data.fullName;
        _this.cardFrom.street = ''
        _this.streetOfficesId = ''
        _this.cardFrom.streetOffices = ''
        _this.streetRegionId = 0
        // 选择第三层加载下面的数据
        if (_this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels.length == 3) {
          _this.Region.Regions(
            _this.$refs["refSubCat"].getCheckedNodes()[0].data.id,
            function (data) {
              _this.streetData = data.data;
            },
            function (err) {
              console.log(err);
            }
          );
        }

    },
    bindPickerChange(e){
        this.cardFrom.typeName = e.value
        this.cardFrom.cardType = e.index
    },
    GetHealthRecordByHealthIdMy() {
        var _this = this
        _this.healthRecordDomain.GetHealthRecordByHealthId(
            _this.healthRecordId,
            function (data) {
                _this.myInfo = data.data
                if (_this.signFamilyType == 1) {
                  _this.getHealthRecordFamilyInfo()
                }
            },
            function (error) {
            console.log(error);
            }
        );
    },
    GetHealthRecordOrganizationList() {
      var _this = this
      let orgKeyWord = _this.keyWord == '' ? '%20' : _this.keyWord
      _this.healthRecordDomain.GetHealthRecordNotSignUserInfo(
        orgKeyWord,
        function (data) {
          _this.hosList = data.data;
        },
        function (error) {
          console.log(error);
          _this.hosList = [];
        }
      );
    },
    goHosDetail(e) {
        if (this.famIndex == -1) {
            this.$message({
                message: '请选择一条数据',
                type: 'warning'
            });
            return
        }
        this.$router.push({
            name: "signingApplyUserDetail",
            query: {
              id: this.famindexDetail.healthRecordId,
              type: e,
              healthRecordFamilyId: this.famindexDetail.healthRecordFamilyId,
            },
        });
    },
    handleClickTop(e, e1) {
      if (e.label == "健康管理") {
        this.$router.push({
          name: "signingApplyList",
        });
      }
    },
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  padding-top: 20px;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 10px auto;
  cursor: pointer;
  margin-bottom: 20px;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #ffffff;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 10px auto;
  cursor: pointer;
  background: #06add7;
  margin-bottom: 20px;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 83%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 10px 40px;
  padding-top: 30px;
}
.titleTopCenterCenterBtn{
  padding: 10px 40px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Content1Title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 0;
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.el-page-header {
  line-height: 73px;
  /* padding-left: 20px; */
}
	.doCboxList {
        background: #ffffff;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
	}
	.doCbox {
		background: #F5FAF9;
		border-radius: 8px;
		padding: 30px;
		margin: 20px 0;
        width: 45%;
	}
	.doCboxChecked {
         width: 45%;
		background: linear-gradient(90deg, #EBFFFF, #FFFFFF);
		border-radius: 8px;
		border: 1px solid #00AFB5;
		padding: 30px;
		margin: 20px 0;
	}
	.doCboxImg {
		width: 64px;
		height: 64px;
	}
	.doCboxImg img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	.doCboxH {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.doCboxHF {
		display: flex;
		align-items: center;
	}
    .gHDocRightTitle {
		font-weight: bold;
		font-size: 18px;
		color: #333333;
		max-width: 200px;
		overflow: hidden;/*超出部分隐藏*/
		white-space: nowrap;/*不换行*/
		text-overflow:ellipsis;/*超出部分文字以...显示*/
		margin-right: 4px;
	}
    .docTag {
		font-size: 12px;
		color: #FFFFFF;
		background: #00AFB5;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
	.docHealthTag {
		font-size: 12px;
		color: #FFFFFF;
		background: #4194E7;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
    .docTagNameCheck {
		font-size: 12px;
		background: #DEF6F6;
		color: #00AFB5;
		border-radius: 3px;
		padding: 2px 5px;
		margin-left: 5px;
	}
	.docTagNameNo {
		font-size: 12px;
		background: #E2E5E7;
		border-radius: 6px;
		color: #666666;
		padding: 5px 10px;
		margin-left: 10px;
	}
    .des {
		color: #333333;
        font-size: 14px;
	}
    .doCboxBtn {
		display: flex;
		align-items: center;
        font-size: 16px;
        color: #333333;
	}
    .numTag2 {
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border-radius: 40px;
		font-size: 20px;
		background-color: #E63838;
		color: #FFFFFF;
		position: absolute;
		right: 30px;
		top: -10px;
	}
    .seeBtnBoxNo {
        color: #00AFB5;
        border: 1px solid #00AFB5;
        border-radius: 4px;
        font-size: 14px;
        padding: 5px 20px;
    }
    .seeBtnBox {
        background: #00AFB5;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
        padding: 5px 20px;
    }
    .boxtagBox {
		display: flex;
		align-items: center;
		margin: 15px 0;
		width: 40%;
		margin: auto;
		background: #EBF3F5;
		border-radius: 16rpx;
		padding: 5px;
	}
    .boxtag {
		width: 50%;
		text-align: center;
		padding: 10px 0;
	}
	.boxtagCheck {
		width: 50%;
		text-align: center;
		padding: 10px 0;
		background: #FFFFFF;
		border-radius: 5px;
	}
    .numTag1 {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #E63838;
		color: #FFFFFF;
		position: absolute;
		right: 30px;
		top: 5px;
	}
    .signAddBox {
        width: 70%;
        margin: 0px auto;
        background: #ffffff
    }
    .signAddTop {
        padding-top: 20px;

    }
    .addDocPerList {
        border-radius: 6px;
        border: 1px solid #DCDFE6;
        padding: 10px 20px;
    }
    .familyTypeBox {
      max-height:70vh;
      position: absolute;
      left: 40px;
      top:40px;
      overflow-y: auto;
    }
    .familyTypeBoxList {
      background: #FDF8F4;
      border-radius: 10px;
      border: 1px solid #E0D4B5;
      padding: 10px 0;
      width: 120px;
      position: relative;
      margin-top: 10px;
    }
    .familyTypeBoxListNo {
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #DCDFE6;
      padding: 10px 0;
      width: 120px;
      position: relative;
      margin-top: 10px;
    }
    .familyTypeBoxListNo img {
      width: 50px;
      height: 50px;
      border-radius:50%;
      margin-left: 50%;
      transform: translateX(-50%);
    }
    .familyTypeBoxList img {
      width: 50px;
      height: 50px;
      border-radius:50%;
      margin-left: 50%;
      transform: translateX(-50%);
    }
    .familyTypeBoxListTag {
      background: #F48C61;
      border-radius: 2px;
      padding: 0px 5px;
      position: absolute;
      bottom: 40px;
      color: #FFFFFF;
      font-size: 12px;
      left: 50%;
      transform: translateX(-50%);
    }
    .familyTypeBoxListSize {
      text-align: center;
      font-size: 14px;
      margin-top: 5px;
    }
</style>
